export default __webpack_public_path__ + "static/media/txt.52db9030.svg";